import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api.service';
import { GetBrandDistributorListResponse, GetDistributorsPublicParams, GetDistributorsResponse } from '../dtos';

@Injectable({
  providedIn: 'root',
})
export class DistributorService {
  constructor(private readonly apiService: ApiService) {}

  getBrandDistributorList(
    brandUuid: string
  ): Observable<GetBrandDistributorListResponse> {
    return this.apiService.get(`/v1/distributors/brand/${brandUuid}/details`);
  }

  /**
   * Get Distributors
   * permissions: {mode: "+r", res: "distributor.*"}
   * @param getDistributorsPublicParams
   */
  getDistributorsPublic(
    getDistributorsPublicParams: GetDistributorsPublicParams
  ): Observable<GetDistributorsResponse> {
    return this.apiService.post(
      '/v2-internal/distributors/name/search',
      getDistributorsPublicParams
    );
  }
}
